module.exports = __webpack_public_path__ + "static/banner-10715312193938a7088a17303bfd4882.jpg";